import { render } from "./mvt-cardproperty.vue?vue&type=template&id=0a919b6e"
import script from "./mvt-cardproperty.js?vue&type=script&lang=js"
export * from "./mvt-cardproperty.js?vue&type=script&lang=js"

import "./mvt-cardproperty.vue?vue&type=style&index=0&id=0a919b6e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__